import * as React from 'react';
import * as classNames from 'classnames';
import withStyles, {WithStyles} from 'original/styles/withStyles';
import Typography, {TypographyProps} from 'original/Typography';

export interface FormExplanationTextProps extends TypographyProps {}

export type FormExplanationTextClassKey = 'root';

export const styles = theme => ({
  root: {
    color: theme.palette.text.secondary,
    marginBottom: -theme.spacing(1),
  },
});

const FormExplanationText: React.SFC<FormExplanationTextProps & WithStyles<FormExplanationTextClassKey>> = props => {
  const {children, classes, className, ...other} = props;
  return (
    <Typography component="div" variant="body2" className={classNames(classes.root, className)} {...other}>
      {children}
    </Typography>
  );
};

export default withStyles(styles, {name: 'MuiFormExplanationText'})(FormExplanationText);
